import { apiRequest } from './axiosConfig';

// ImagePromptTemplate型定義
export interface ImagePromptTemplate {
  id: number;
  name: string;
  type: 'single' | 'variations';
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// 作成リクエスト型
export interface ImagePromptTemplateCreateRequest {
  name: string;
  type: 'single' | 'variations';
  content: string;
  is_active?: boolean;
}

// 更新リクエスト型
export interface ImagePromptTemplateUpdateRequest {
  name: string;
  type: 'single' | 'variations';
  content: string;
  is_active?: boolean;
}

// APIレスポンス型
interface ImagePromptTemplatesResponse {
  success: boolean;
  data: ImagePromptTemplate[];
}

interface ImagePromptTemplateResponse {
  success: boolean;
  data: ImagePromptTemplate;
  message?: string;
}

interface DeleteResponse {
  success: boolean;
  message: string;
}

const imagePromptTemplateService = {
  /**
   * プロンプトテンプレート一覧取得
   */
  async getAllTemplates(): Promise<ImagePromptTemplate[]> {
    const response = await apiRequest.get<ImagePromptTemplatesResponse>('admin/image-prompt-templates');
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('プロンプトテンプレート一覧の取得に失敗しました');
  },

  /**
   * プロンプトテンプレート詳細取得
   */
  async getTemplate(id: number): Promise<ImagePromptTemplate> {
    const response = await apiRequest.get<ImagePromptTemplateResponse>(`admin/image-prompt-templates/${id}`);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('プロンプトテンプレートの取得に失敗しました');
  },

  /**
   * プロンプトテンプレート作成
   */
  async createTemplate(data: ImagePromptTemplateCreateRequest): Promise<ImagePromptTemplate> {
    const response = await apiRequest.post<ImagePromptTemplateResponse>('admin/image-prompt-templates', data);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('プロンプトテンプレートの作成に失敗しました');
  },

  /**
   * プロンプトテンプレート更新
   */
  async updateTemplate(id: number, data: ImagePromptTemplateUpdateRequest): Promise<ImagePromptTemplate> {
    const response = await apiRequest.put<ImagePromptTemplateResponse>(`admin/image-prompt-templates/${id}`, data);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('プロンプトテンプレートの更新に失敗しました');
  },

  /**
   * プロンプトテンプレート削除
   */
  async deleteTemplate(id: number): Promise<void> {
    const response = await apiRequest.delete<DeleteResponse>(`admin/image-prompt-templates/${id}`);
    if (!response.success) {
      throw new Error(response.message || 'プロンプトテンプレートの削除に失敗しました');
    }
  },

  /**
   * プロンプトテンプレート有効化
   */
  async activateTemplate(id: number): Promise<ImagePromptTemplate> {
    const response = await apiRequest.put<ImagePromptTemplateResponse>(`admin/image-prompt-templates/${id}/activate`);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('プロンプトテンプレートの有効化に失敗しました');
  }
};

export default imagePromptTemplateService;
